import { ChevronDownIcon } from '@heroicons/react/24/solid';
//@ts-ignore
import { GB, IS } from 'country-flag-icons/react/1x1';
// import { GB, IS, SE, NO, ES, FR, DE } from 'country-flag-icons/react/3x2';
import { useState } from 'react';
import { localize } from '../../libs/Localization';
import { flagType } from '../../types/misc';

const LanguageSelector = ({ collapsed }: { collapsed: boolean }) => {
	const [hide, setHide] = useState<boolean>(true);
	const currentLanguage = localize.getLanguage();

	const changeLanguage = (newLanguage: string) => {
		localStorage.setItem('localization', `"${newLanguage}"`);
		window.location.reload();
	};

	const flags: flagType = {
		English: {
			smallFlag: <GB className='w-6 h-6 rounded-full' />,
			bigFlag: <GB className='w-10 h-10 rounded-full m-2 ' />,
		},
		Icelandic: {
			smallFlag: <IS className='w-6 h-6 rounded-full' />,
			bigFlag: <IS className='w-10 h-10 rounded-full m-2' />,
		},
		// Swedish: {
		// 	smallFlag: <SE className='w-6' />,
		// 	bigFlag: <SE className='w-12 m-2' />,
		// },
		// Norwegian: {
		// 	smallFlag: <NO className='w-6' />,
		// 	bigFlag: <NO className='w-12 m-2' />,
		// },
		// Spanish: {
		// 	smallFlag: <ES className='w-6' />,
		// 	bigFlag: <ES className='w-12 m-2' />,
		// },
		// French: {
		// 	smallFlag: <FR className='w-6' />,
		// 	bigFlag: <FR className='w-12 m-2' />,
		// },
		// German: {
		// 	smallFlag: <DE className='w-6' />,
		// 	bigFlag: <DE className='w-12 m-2' />,
		// },
	};

	if (collapsed) {
		return (
			<div className='flex flex-col w-full'>
				<button onClick={() => setHide(!hide)} className='flex px-4 py-2 place-content-center w-full bg-white' aria-label="Select Language">
					{flags[currentLanguage].smallFlag}
				</button>
				<div className={`${hide ? 'hidden' : ''} duration-300 w-full bg-white pb-1`}>
					{Object.entries(flags).map(([country, flag]) => {
						if (country !== currentLanguage) {
							return (
								<button
									key={country}
									onClick={() => changeLanguage(`${country}`)}
									className={`flex my-0.5 grow w-full place-content-center hover:bg-blue-100`}
								>
									{flag.smallFlag}
								</button>
							);
						}
						return null;
					})}
				</div>
			</div>
		);
	}

	return (
		<div className='flex flex-col w-full'>
			<button
				onClick={() => setHide(!hide)}
				className='flex px-4 py-2 bg-white place-items-center place-content-between w-full'
			>
				<div className='flex'>
					{currentLanguage in flags && flags[currentLanguage].smallFlag}
					<div className='mx-2'>{currentLanguage}</div>
				</div>
				<ChevronDownIcon className={`ml-2.5 w-6 h-6 ${hide ? '' : 'rotate-180'}`} />
			</button>
			<div className={`${hide ? 'hidden' : ''} duration-300 w-full bg-white`}>
				{Object.entries(flags).map(([country, flag]) => {
					if (country !== currentLanguage) {
						return (
							<button
								key={country}
								onClick={() => changeLanguage(`${country}`)}
								className={`flex grow w-full place-items-center hover:bg-blue-100`}
							>
								{flag.bigFlag}
								<div className='mr-2'>{country}</div>
							</button>
						);
					}
					return null;
				})}
			</div>
		</div>
	);
};

export default LanguageSelector;
